import { TextExpander } from './text-expander.component';

export default angular
  .module('sfMobile.components.text-expander', [
    'sfMobile.components.text-expander',
  ])
  .component('sfTextExpander', TextExpander).name;
